import { useCallback } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Feedback, useResource } from "@/components/workflow/shared";
import { hasInvoicePermission, receivedInvoices } from "@/lib/receivedInvoices";
import { cn } from "@/lib/utils";

export function ReceivedInvoiceHomeTile() {
  const { user } = useAuth();
  const allowed = hasInvoicePermission(user) && hasInvoicePermission(user, "odobri_placanje");
  const resource = useResource(`invoice-approvals-home:${user?.id}:${allowed}`, useCallback(async (signal) => {
    if (!allowed) return null;
    const rows = await receivedInvoices.list(signal);
    return rows.filter((row) => ["ceka_upravu", "ceka_placanje"].includes(row.stanje)).length;
  }, [allowed]));

  if (!allowed) return null;
  return (
    <div className="mb-3 space-y-3">
      <Feedback error={resource.error} />
      <Link
        className={cn("block rounded-xl border p-4 font-semibold", (resource.data ?? 0) > 0 && "bg-amber-50 text-amber-950")}
        to="/nabava/ulazni-racuni/uprava"
      >
        Računi za odobrenje plaćanja ({resource.loading ? "…" : resource.data ?? "—"})
      </Link>
    </div>
  );
}
